
class ProductPresetsGroupDetailCell extends MUITableViewCell
{
    private nameLabel:MUILabel = null;

    awakeFromHTML()
    {
        this.nameLabel = MUIOutlet(this, "name-lbl", "MUILabel");
        //this.separatorStyle = MUITableViewCellSeparatorStyle.None;
    }

    set item(i:any)
    {
        //more cell properties here
        this.nameLabel.text = i.name;
    }

}